import React from 'react';

const BlackTitlePurpleSubTitle = ({title, purpleSubTitle}) => {
  return (
    <div className='black-title-purple-sub-title'>
      <span className='black-title'>{title}</span>
      <span className='purple-sub-title'>{purpleSubTitle}</span>
    </div>
  );
}

export default BlackTitlePurpleSubTitle;
